export var SwapStatus;
(function (SwapStatus) {
    SwapStatus["Created"] = "created";
    SwapStatus["UserTransferPending"] = "user_transfer_pending";
    SwapStatus["UserTransferDelayed"] = "user_transfer_delayed";
    SwapStatus["LsTransferPending"] = "ls_transfer_pending";
    SwapStatus["Completed"] = "completed";
    SwapStatus["Failed"] = "failed";
    SwapStatus["Expired"] = "expired";
    SwapStatus["Cancelled"] = "cancelled";
    SwapStatus["PendingRefund"] = "pending_refund";
    SwapStatus["Refunded"] = "refunded";
})(SwapStatus || (SwapStatus = {}));
